import React from 'react'
import Incomigdata from './Table/Incomigdata'
import TableData from "./Table/TableData"
export default function Incoming() {
  return (
    <div>
    <div className="flex flex-wrap justify-center">
    <div
      className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
      // "w-[calc(100vw_-_12rem)]"
    >
      <TableData />
    </div>
</div>
<h2 class="mt-2 mb-1">
<div
  class="
relative
flex
items-center
w-full
py-4
px-5
font-semibold
font-Montserrat
text-base text-blue-200 text-left
bg-transparent
border-0
rounded-none
transition
focus:outline-none
"
>
  <svg
    className="mr-2 hover:rotate-180"
    width="15"
    height="10"
    viewBox="0 0 15 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6582 1.07812L7.50031 7.57812L1.00031 1.07813"
      stroke="#1F78B4"
      stroke-width="2"
    />
  </svg>{" "}
  All Incoming Deliveries
</div>
</h2>
<div className="flex flex-wrap justify-center">
<div
  className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
  // "w-[calc(100vw_-_12rem)]"
>
  <Incomigdata />
</div>
</div>
    </div>
  )
}
